/* WEDOART-IL wishlist account sync. Keeps the browser list (wd_wishlist_v1) in step with the
   logged-in customer's list stored by the wishlist app proxy at /apps/wishlist. */
(function () {
  'use strict';
  var KEY = 'wd_wishlist_v1', CK = 'wd_wl', SYNC = 'wd_wl_synced_uid', URL = '/apps/wishlist';
  var uid = window.wdWlCustomer;
  var applying = false, timer = null, ready = false;

  function readLocal() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; }
  }
  function notify() {
    try { window.dispatchEvent(new StorageEvent('storage', { key: KEY })); } catch (e) {}
  }
  function applyLocal(list) {
    applying = true;
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    applying = false;
    try {
      document.cookie = CK + '=' + list.slice(0, 50).map(encodeURIComponent).join('~') + '; path=/; max-age=31536000; SameSite=Lax';
    } catch (e) {}
    notify();
  }
  function same(a, b) { return a.length === b.length && a.every(function (x, i) { return x === b[i]; }); }

  /* Logged out: if a previous customer's list is still on this browser, clear it. */
  if (!uid) {
    try {
      if (localStorage.getItem(SYNC)) {
        applying = true;
        localStorage.removeItem(KEY);
        localStorage.removeItem(SYNC);
        applying = false;
        document.cookie = CK + '=; path=/; max-age=0';
        notify();
      }
    } catch (e) {}
    return;
  }

  function push() {
    if (!ready) return;
    fetch(URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ handles: readLocal() })
    }).catch(function () {});
  }
  function schedulePush() {
    clearTimeout(timer);
    timer = setTimeout(push, 600);
  }

  /* Detect list changes made by the main wishlist script. */
  var origSet = Storage.prototype.setItem;
  Storage.prototype.setItem = function (k, v) {
    origSet.apply(this, arguments);
    if (k === KEY && !applying && this === window.localStorage) schedulePush();
  };

  fetch(URL, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
    .then(function (r) { if (!r.ok) throw new Error('sync'); return r.json(); })
    .then(function (d) {
      if (!d || !d.customer) return;
      var server = Array.isArray(d.handles) ? d.handles : [];
      var local = readLocal();
      var first = localStorage.getItem(SYNC) !== String(uid);
      var next;
      if (first) {
        next = local.slice();
        server.forEach(function (h) { if (next.indexOf(h) === -1) next.push(h); });
        try { localStorage.setItem(SYNC, String(uid)); } catch (e) {}
      } else {
        next = server;
      }
      if (!same(next, local)) applyLocal(next);
      ready = true;
      if (!same(next, server)) push();
    })
    .catch(function () {});
})();
